import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"
import _imports_0 from '@/assets/img/icon/user-outline-black.svg'
import _imports_1 from '@/assets/img/icon/idCard-outline-black.svg'
import _imports_2 from '@/assets/img/icon/tablet-outline-black.svg'
import _imports_3 from '@/assets/img/icon/mail-outline-black.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-10" }
const _hoisted_3 = { class: "col-span-1 md:col-span-9" }
const _hoisted_4 = { class: "md:flex items-center" }
const _hoisted_5 = { class: "self-baseline" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "md:px-4 flex flex-col w-full" }
const _hoisted_8 = { class: "sm:flex pb-3 justify-between" }
const _hoisted_9 = { class: "text-2xl title font-bold self-baseline" }
const _hoisted_10 = { class: "flex md:hidden gap-4 items-center" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "block md:flex items-center body" }
const _hoisted_13 = {
  key: 0,
  class: "px-2 flex items-center border-none md:border-solid border-r border-neutral-400"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-lock text-xs" }, null, -1)
const _hoisted_15 = { class: "flex ml-2 items-center text-xs text-grey" }
const _hoisted_16 = {
  key: 1,
  class: "px-2 block md:flex items-center border-none md:border-solid border-r border-neutral-400 gap-4"
}
const _hoisted_17 = { class: "flex items-center gap-1" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_19 = { class: "items-center text-xs text-grey" }
const _hoisted_20 = { class: "flex items-center gap-1" }
const _hoisted_21 = { class: "items-center text-xs text-grey" }
const _hoisted_22 = {
  key: 2,
  class: "px-2 flex items-center border-none md:border-solid border-r border-neutral-400"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_24 = { class: "flex ml-2 items-center text-xs text-grey" }
const _hoisted_25 = { class: "px-2 hidden md:flex items-center" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_27 = { class: "items-center text-xs text-grey ml-2" }
const _hoisted_28 = {
  key: 3,
  class: "px-2 hidden md:flex items-center"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1)
const _hoisted_30 = { class: "items-center text-xs text-grey ml-2" }
const _hoisted_31 = { class: "border-solid border-t border-neutral-400 block md:hidden mt-4 pt-4 pb-2" }
const _hoisted_32 = { class: "flex items-center" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_34 = { class: "items-center text-xs text-grey ml-2" }
const _hoisted_35 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1)
const _hoisted_37 = { class: "items-center text-xs text-grey ml-2" }
const _hoisted_38 = { class: "hidden md:flex flex-col justify-between items-end" }
const _hoisted_39 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_InlineSvg = _resolveComponent("InlineSvg")!
  const _component_Card = _resolveComponent("Card")!
  const _component_HjpDataList = _resolveComponent("HjpDataList")!
  const _component_ListActions = _resolveComponent("ListActions")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_HjpConfirmationModal = _resolveComponent("HjpConfirmationModal")!

  return (!_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_HjpDataList, _normalizeProps(_guardReactiveProps(_ctx.params)), {
          content: _withCtx(({ dataItems }) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataItems, (data, idx) => {
              return (_openBlock(), _createBlock(_component_Card, {
                class: "card-item mb-6 wrap-card-route",
                key: idx
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("img", {
                            class: "self-baseline",
                            src: _ctx.role === 'Kontroler' ? require('@/assets/img/icon/controller-yellow.svg') : _ctx.role === 'Sopir' ? require('@/assets/img/icon/driver-black.svg') : _ctx.role === 'Pembantu' ? require('@/assets/img/icon/helper-black.svg') : require('@/assets/img/icon/conductor-blue.svg'),
                            style: {"min-width":"40px","height":"40px"},
                            alt: ""
                          }, null, 8, _hoisted_6)
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("p", _hoisted_9, _toDisplayString(`${data.IdCardNumber}-${data.Fullname}`), 1),
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("i", {
                                class: "pi pi-ellipsis-h text-base cursor-pointer color-dark",
                                onClick: ($event: any) => (_ctx.showDropDown($event, data))
                              }, null, 8, _hoisted_11),
                              _createVNode(_component_InputSwitch, {
                                class: "input-success",
                                modelValue: data.IsActive,
                                "onUpdate:modelValue": ($event: any) => ((data.IsActive) = $event),
                                onChange: ($event: any) => (_ctx.onChangeActivate(data))
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            (_ctx.role === 'Kondektur')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  _hoisted_14,
                                  _createElementVNode("div", _hoisted_15, "Bank Credential ID: " + _toDisplayString(data.IdCorporate ? 'ON' : 'OFF'), 1)
                                ]))
                              : (_ctx.role === 'Kontroler')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                    _createElementVNode("div", _hoisted_17, [
                                      _hoisted_18,
                                      _createElementVNode("p", _hoisted_19, _toDisplayString(data.Username), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_20, [
                                      _createVNode(_component_InlineSvg, {
                                        src: require('@/assets/img/icon/nfc-outline-black.svg')
                                      }, null, 8, ["src"]),
                                      _createElementVNode("p", _hoisted_21, "NFC Tag: " + _toDisplayString(data.NFCTag), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                            (_ctx.role === 'Sopir' || _ctx.role === 'Pembantu')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                  _hoisted_23,
                                  _createElementVNode("div", _hoisted_24, "No. KTP/SIM: " + _toDisplayString(data.NIK), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_25, [
                              _hoisted_26,
                              _createElementVNode("p", _hoisted_27, _toDisplayString(data.PhoneNumber), 1)
                            ]),
                            (_ctx.role !== 'Sopir' && _ctx.role !== 'Pembantu')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                  _hoisted_29,
                                  _createElementVNode("p", _hoisted_30, _toDisplayString(data.Email), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _hoisted_33,
                              _createElementVNode("p", _hoisted_34, _toDisplayString(data.PhoneNumber), 1)
                            ]),
                            (_ctx.role !== 'Sopir' && _ctx.role !== 'Pembantu')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                  _hoisted_36,
                                  _createElementVNode("p", _hoisted_37, _toDisplayString(data.Email), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("i", {
                        class: "pi pi-ellipsis-h text-base cursor-pointer color-dark",
                        onClick: ($event: any) => (_ctx.showDropDown($event, data))
                      }, null, 8, _hoisted_39),
                      _createVNode(_component_InputSwitch, {
                        class: "input-success",
                        modelValue: data.IsActive,
                        "onUpdate:modelValue": ($event: any) => ((data.IsActive) = $event),
                        onChange: ($event: any) => (_ctx.onChangeActivate(data))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 16),
        _createVNode(_component_OverlayPanel, { ref: "op" }, {
          default: _withCtx(() => [
            _createVNode(_component_ListActions, {
              edit: true,
              del: false,
              reset: false,
              resetTitle: "Reset Password",
              editTitle: "Edit Akun",
              delTitle: "Hapus Akun",
              onDel: _ctx.onDelete,
              onEdit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onEdit(_ctx.dataRow.Id))),
              onReset: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resetPassword(_ctx.dataRow.Id)))
            }, null, 8, ["onDel"])
          ]),
          _: 1
        }, 512),
        _createVNode(_component_HjpConfirmationModal, {
          show: _ctx.attrModalConfirmation.show,
          imgContent: _ctx.attrModalConfirmation.imgContent,
          title: _ctx.attrModalConfirmation.title,
          subTitle: _ctx.attrModalConfirmation.subTitle,
          btnSubmitTitle: _ctx.attrModalConfirmation.btnSubmitTitle,
          onHideDialog: _ctx.hideDialogConfirmation,
          onOnSubmit: _ctx.onSubmitConfirmation
        }, null, 8, ["show", "imgContent", "title", "subTitle", "btnSubmitTitle", "onHideDialog", "onOnSubmit"])
      ]))
    : _createCommentVNode("", true)
}